import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=f5638858&scoped=true"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"
import style0 from "./index copy.vue?vue&type=style&index=0&id=f5638858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5638858",
  null
  
)

export default component.exports